<template>
  <div class="container">
    <section>
      <h2>沟通</h2>
      <a class="close" @click="closePage"
        ><a-icon style="font-size:30px;color:#666" type="close-circle"
      /></a>
      <a-form-model
        class="ruleForm"
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="类型" prop="type">
          <a-radio-group v-model="ruleForm.type">
            <a-radio :value="1">电话</a-radio>
            <a-radio :value="2">面访</a-radio>
            <a-radio :value="3">社交APP</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="沟通内容" prop="communicate">
          <a-input v-model="ruleForm.communicate" type="textarea" />
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 10 }">
          <a-button type="primary" @click="onSubmit">
            提交
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </section>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
      ruleForm: {
        type: "",
        communicate: ""
      },
      rules: {
        type: [
          {
            required: true,
            message: "请选择类型",
            trigger: "change"
          }
        ],
        communicate: [
          {
            required: true,
            message: "请输入沟通内容",
            trigger: "blur"
          },
          {
            min: 6,
            message: "沟通记录长度大于6",
            trigger: "blur"
          }
        ]
      }
    };
  },
  props: {
    communicationListID: null
  },
  methods: {
    closePage() {
      this.$emit("hideIsCommunication", false);
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let url =
            this.httpsBasic.url +
            this.httpsBasic.resume +
            "Resume_new/addCommunicate";
          // console.log(this.ruleForm);
          let params = {
            resume_id: this.communicationListID,
            type: this.ruleForm.type,
            communicate: this.ruleForm.communicate,
            token: window.localStorage.getItem("xnwfPcToken")
          };
          //   console.log(params);
          axios.post(url, params).then(res => {
            if (res.data.code == 200) {
              this.$message.success("提交成功");
              this.$refs.ruleForm.resetFields();
              this.$emit("hideIsCommunication", true);
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
  > section {
    background: #fff;
    position: absolute;
    top: 20%;
    left: 30%;
    min-width: 40%;
    padding: 30px 4% 10px;
    border-radius: 10px;
    h2 {
      text-align: center;
      font-size: 18px;
      margin-bottom: 10px;
    }
    .close {
      position: absolute;
      right: 14px;
      top: 10px;
    }
  }
}
</style>
